// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-7f7d47b1] {\n  fill: #fff;\n}\n.st5[data-v-7f7d47b1] {\n  fill: #a1e7fc;\n}\n.st6[data-v-7f7d47b1] {\n  fill: #e94766;\n}\n.st7[data-v-7f7d47b1] {\n  fill: #0790cb;\n}\n.st9[data-v-7f7d47b1] {\n  fill: #f2a19c;\n}\n.st11[data-v-7f7d47b1] {\n  fill: #151a4f;\n}\n.st12[data-v-7f7d47b1] {\n  fill: #23286b;\n}\n.st15[data-v-7f7d47b1] {\n  fill: #1A7BEE;\n}\n.st26[data-v-7f7d47b1] {\n  fill: #ffbeb6;\n}\n.st27[data-v-7f7d47b1] {\n  fill: #e13b38;\n}\n", ""]);
// Exports
module.exports = exports;
